<template>
  <div class="d-flex flex-row p-3">
    <!-- Product name & Description -->
    <div class="d-flex flex-column text-start flex-grow-1 pe-2">
      <div class="scss-overflow-text-style">
        <span class="$large-font-size scss-bold">{{ name }}</span>
      </div>
      <div class="scss-overflow-text-style">
        <span> Transaction Status: {{ paymentStatus }} </span>
      </div>
      <div class="scss-overflow-text-style">
        <span> Outlet: {{ branchName }} </span>
      </div>
      <div class="scss-overflow-text-style">
        <span class="scss-text-light-color">
          {{ date }}
        </span>
      </div>
    </div>

    <!-- Price -->
    <div
      class="d-flex align-items-center"
      v-if="!hidePrice"
    >
      <span class="pe-1">{{ branchCurrencySymbol }}</span>
      <span>{{ price }}</span>
    </div>
  </div>

  <div class="border-bottom"></div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "HistoryItemList",
  props: {
    name: String,
    date: String,
    price: String,
    hidePrice: {
      type: [Boolean, Number],
      default: false,
    },
    paymentStatus: String,
    branchName: String,
  },
  computed: {
    ...mapGetters(["branchCurrencySymbol"]),
  },
};
</script>
